var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallFarmer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 81",
    filter: "url(#filter0_d_7797_22747)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 80,
    height: 80,
    rx: 20,
    fill: "#63C998"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 79,
    height: 79,
    rx: 19.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6816 65.0058L14.9966 61.596C16.0569 58.8397 18.0236 56.4865 20.5402 54.9659C24.853 52.3908 28.5026 53.2507 30.3249 53.0987C32.194 53.0987 33.7147 51.5663 33.7147 49.6823V48.2567C31.4042 46.1368 29.6596 43.1998 28.8542 39.8308C23.0753 38.2467 18.8672 35.5657 18.8672 31.8788C18.8672 28.0281 23.4512 25.2708 29.6269 23.7185L31.845 17.1526C32.8859 14.0704 35.7463 12 38.9624 12H45.6946C48.9095 12 51.7699 14.0706 52.8132 17.1526L55.0298 23.7171C61.2087 25.2692 65.7957 28.0269 65.7957 31.8788C65.7957 35.5675 61.5882 38.2526 55.8042 39.8361C54.9987 43.2006 53.2538 46.1351 50.9428 48.2541V49.6822C50.9428 51.5661 52.4622 53.0986 54.3297 53.0986C56.289 53.262 59.8772 52.4357 64.118 54.9687C66.6246 56.4797 68.5965 58.8318 69.6723 61.5964L70.9845 65.0142C72.2726 68.3744 69.8204 72 66.2602 72H18.4017C14.843 72 12.3887 68.3693 13.6816 65.0058ZM58.4887 55.6115C57.8822 59.2005 54.7879 61.9405 51.0724 61.9405H33.5842C29.8688 61.9405 26.7744 59.2005 26.168 55.6116C24.8289 55.7513 23.4977 56.1614 22.3657 56.7462V69.5505H62.2909V56.7474C61.1458 56.157 59.8276 55.7522 58.4887 55.6115ZM50.5237 17.9455C49.8165 15.8541 47.8753 14.449 45.6948 14.449H38.9626C36.781 14.449 34.8409 15.8534 34.135 17.9449L32.3856 23.1236C38.7561 21.9585 45.9008 21.9582 52.2721 23.1227L50.5237 17.9455ZM63.3762 31.8788C63.3762 28.4822 54.7333 24.6975 42.331 24.6975C29.9292 24.6975 21.287 28.4822 21.287 31.8788C21.287 33.7626 23.9496 35.7642 28.4336 37.1746C28.3954 36.0907 28.3779 31.4169 28.3666 30.9844C28.3518 30.4641 28.6644 29.9906 29.1452 29.8053C36.4946 26.9718 48.5335 27.0784 55.5178 29.822C55.9933 30.0085 56.3024 30.4779 56.2893 30.9939C56.2764 31.5598 56.2595 36.0759 56.2244 37.176C60.7117 35.7656 63.3762 33.7633 63.3762 31.8788ZM53.8036 37.1953C53.8274 36.8269 53.8535 32.8498 53.8615 31.8209C47.3949 29.6258 37.3771 29.613 30.7947 31.812C30.8016 32.5282 30.8273 36.7876 30.8538 37.1685C31.5048 43.8757 36.6503 49.3327 42.3233 49.3327C48.0029 49.3326 53.1536 43.8756 53.8036 37.1953ZM48.5413 50.0405C46.6506 51.1528 44.5322 51.7816 42.3233 51.7816C40.1187 51.7816 38.0041 51.1541 36.1164 50.0437C35.93 53.1093 33.4074 55.5477 30.325 55.5477H28.632C29.1762 57.8078 31.1867 59.4913 33.5842 59.4913H51.0724C53.4696 59.4913 55.4778 57.8071 56.0229 55.5477H54.3299C51.2475 55.5477 48.7259 53.1075 48.5413 50.0405ZM68.729 65.9008L67.4187 62.4887C66.8235 60.959 65.8857 59.5894 64.7107 58.4775V69.551H66.2602C68.1172 69.551 69.4055 67.6661 68.729 65.9008ZM18.4018 69.551H19.9459V58.4784C18.7712 59.5916 17.8383 60.9595 17.2515 62.4856L15.9359 65.8954C15.2604 67.6544 16.5362 69.551 18.4018 69.551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7797_22747",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7797_22747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7797_22747",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFarmer);
export default __webpack_public_path__ + "static/media/smallFarmer.ad136f186c04eb1b97e3cdacea5ee801.svg";
export { ForwardRef as ReactComponent };